export default __webpack_public_path__ + "static/gateCode-368795799a4b0c1984a8c4fd3f6d3ef4.svg";